import { isOriginAuthor, OriginAuthor } from "../Explore.model";

export function getOriginAuthorText(value: OriginAuthor): string {
  switch (value) {
    case "AGENT":
      return "Agent";
    case "USER":
      return "User";
    default:
      return value;
  }
}

export function OriginAuthorFormatter({ value }: { value: string }) {
  if (value == null || !isOriginAuthor(value)) {
    return <></>;
  }

  return <>{getOriginAuthorText(value)}</>;
}
